import React from 'react'
import { Facebook, Instagram, Youtube } from 'lucide-react'

const SocialSidebar = () => {
  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/lasgardeniasIED',
      icon: Facebook,
      color: 'hover:bg-[#1877F2]',
      ariaLabel: 'Síguenos en Facebook'
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/lasgardeniasIED/',
      icon: Instagram,
      color: 'hover:bg-gradient-to-br hover:from-[#833AB4] hover:via-[#E1306C] hover:to-[#F77737]',
      ariaLabel: 'Síguenos en Instagram'
    },
    {
      name: 'X (Twitter)',
      url: 'https://www.x.com/lasgardeniasIED',
      icon: () => (
        <svg
          viewBox="0 0 24 24"
          className="h-5 w-5 sm:h-6 sm:w-6"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      ),
      color: 'hover:bg-black',
      ariaLabel: 'Síguenos en X (Twitter)'
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com',
      icon: Youtube,
      color: 'hover:bg-[#FF0000]',
      ariaLabel: 'Síguenos en YouTube'
    }
  ]

  return (
    <div className="fixed right-0 top-1/2 transform -translate-y-1/2 z-40 hidden md:block">
      <div className="flex flex-col space-y-2">
        {socialLinks.map((social, index) => {
          const IconComponent = social.icon
          return (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.ariaLabel}
              className={`group relative flex items-center justify-center w-12 h-12 bg-gardenia-dark text-white transition-all duration-300 ${social.color} hover:w-16 shadow-lg`}
              style={{
                borderTopLeftRadius: '0.5rem',
                borderBottomLeftRadius: '0.5rem'
              }}
            >
              {/* Icon */}
              <span className="relative z-10">
                {typeof IconComponent === 'function' && IconComponent.name === undefined ? (
                  <IconComponent />
                ) : (
                  <IconComponent className="h-5 w-5 sm:h-6 sm:w-6" />
                )}
              </span>

              {/* Tooltip */}
              <span className="absolute right-full mr-2 px-3 py-1 bg-gardenia-dark text-white text-sm font-medium rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
                {social.name}
              </span>

              {/* Shine effect */}
              <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></span>
            </a>
          )
        })}
      </div>
    </div>
  )
}

export default SocialSidebar